class SideBySide {  
	constructor(el) {
		this.el = el;
		this.cardScrolls = this.el.querySelectorAll('.block-side-by-side__cards');
		this.activeIndex = 0; 

		this.adjustContentPosition(); 
		window.addEventListener('resize', this.adjustContentPosition);
	}

	adjustContentPosition = () => {
		const cardScrolls = this.el.querySelectorAll('.block-side-by-side__card-content-scroll');
		cardScrolls.forEach((scroll) => {
			this.setAlignment(scroll);
		});
	}
	
	setAlignment = (wrapper) => {
		if (!wrapper) return;
		if (wrapper.scrollHeight <= wrapper.clientHeight) {
			wrapper.style.justifyContent = 'center';
		} else {
			wrapper.style.justifyContent = 'flex-start';
		}
	}
	
	
}

export default SideBySide;
